import type { Node, Rect, XYPosition } from '../types';

/** A node as the box select sees it: where it is and how big it was measured. */
export type BoxSelectCandidate = { node: Node; positionAbsolute: XYPosition; width: number | null; height: number | null };

/** The rectangle spanned by two corners, whichever way it was dragged. */
export const rectFromCorners = (a: XYPosition, b: XYPosition): Rect => ({
  x: Math.min(a.x, b.x),
  y: Math.min(a.y, b.y),
  width: Math.abs(b.x - a.x),
  height: Math.abs(b.y - a.y),
});

/** Ids of measured, selectable, visible nodes that lie fully inside `rect` (v11 `SelectionMode.Full`). */
export const getNodeIdsInside = (candidates: readonly BoxSelectCandidate[], rect: Rect): string[] =>
  candidates
    .filter(({ node, positionAbsolute, width, height }) => {
      if (!width || !height || node.hidden || node.selectable === false) return false;
      return (
        positionAbsolute.x >= rect.x &&
        positionAbsolute.y >= rect.y &&
        positionAbsolute.x + width <= rect.x + rect.width &&
        positionAbsolute.y + height <= rect.y + rect.height
      );
    })
    .map(({ node }) => node.id);
